// deps
import React, { memo } from "react";

// internal-deps
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";

// constants
import { ONE_UPSELL_BENEFITS_HALFCARD } from "@dineout-cart-client/constants";

const BenefitsHalfcard = (props: {
    showBenefitsHalfcard: boolean;
    hideSwiggyOneBenefitsHalfcard: () => void;
}): React.ReactElement => {
    const { showBenefitsHalfcard, hideSwiggyOneBenefitsHalfcard } = props;

    return (
        <HalfCard isOpen={showBenefitsHalfcard} onClose={hideSwiggyOneBenefitsHalfcard}>
            <div>
                <Image src={getCloudinaryUrl(ONE_UPSELL_BENEFITS_HALFCARD.imageSrc)} alt="" />
                <FullWidthButton variant="primary" onClick={hideSwiggyOneBenefitsHalfcard}>
                    {ONE_UPSELL_BENEFITS_HALFCARD.ctaText}
                </FullWidthButton>
            </div>
        </HalfCard>
    );
};

export default memo(BenefitsHalfcard);
